import { render, staticRenderFns } from "./fdInventory22.vue?vue&type=template&id=7a2dade0"
import script from "./fdInventory22.vue?vue&type=script&lang=js"
export * from "./fdInventory22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports